import * as Camera from './Camera.js';
import { servObj } from './init_glob.js';
import { dayHDRI, nightHDRI, setNightMode } from './scene.js';
import {applyRoofColor} from "./house_configurate.js"

const activeViewMode = servObj.activeViewMode;
const scene = servObj.scene;

document.querySelector('#view-3d').addEventListener('pointerdown', () => {
    applyRoofColor(servObj.house.roofColor)
    const annotations = document.querySelectorAll('.ann_point');

    if (activeViewMode.is3d === true) return;
    activeViewMode.setViewMode('3d');
    servObj.isFPV = false;

    annotations.forEach((el) => {
        el.classList.toggle('d-none', false);
    });

    document.querySelector('#camera-autorotate').style.opacity = 1;
    document.querySelector('#camera-autorotate').style.pointerEvents = 'auto';

    scene.setActiveCamera(servObj.perspectiveCamera);

    document.querySelector('#view-3d').classList.add('active');
    document.querySelector('#view-2d').classList.remove('active');
    document.querySelector('#view-fpv').classList.remove('active');

    const importedCamera = scene.getObjectByName('camera');
    const importedCameraTarget = scene.getObjectByName('camera_target');

    servObj.perspectiveCamera.name = importedCamera.name;
    servObj.perspectiveCamera.controls.setLookAt(
        importedCamera.position.x,
        importedCamera.position.y,
        importedCamera.position.z,
        importedCameraTarget.position.x,
        importedCameraTarget.position.y,
        importedCameraTarget.position.z
    );

    servObj.perspectiveCamera.controls.enabled = true;
    servObj.orthoCamera.controls.enabled = false;
    servObj.fpvCamera.controls.enabled = false;

    setNightMode(servObj.nightMode);
    applyRoofColor(servObj.house.roofColor)
});

document.querySelector('#view-2d').addEventListener('pointerdown', () => {
    const annotations = document.querySelectorAll('.ann_point');

    if (activeViewMode.is2d === true) return;
    activeViewMode.setViewMode('2d');
    servObj.isFPV = false;

    annotations.forEach((el) => {
        if (el.classList.contains('d-none')) return;
        el.classList.add('d-none');
    });

    document.querySelector('#camera-autorotate').style.opacity = 0;
    document.querySelector('#camera-autorotate').style.pointerEvents = 'none';

    servObj.autorotate = true;
    let event = new Event('pointerdown');
    document.querySelector('#camera-autorotate button').dispatchEvent(event);

    //document.querySelector("#camera-autorotate button").classList.remove("active")

    scene.setActiveCamera(servObj.orthoCamera);

    const importedCameraTarget = scene.getObjectByName('camera_target');
    servObj.orthoCamera.controls.setLookAt(
        importedCameraTarget.position.x,
        50,
        importedCameraTarget.position.z,
        importedCameraTarget.position.x,
        importedCameraTarget.position.y,
        importedCameraTarget.position.z
    );
    servObj.orthoCamera.controls.zoomTo(1.5, false);
    servObj.orthoCamera.controls.dollySpeed = 2.25;

    document.querySelector('#view-3d').classList.remove('active');
    document.querySelector('#view-2d').classList.add('active');
    document.querySelector('#view-fpv').classList.remove('active');

    servObj.perspectiveCamera.controls.enabled = false;
    servObj.orthoCamera.controls.enabled = true;
    servObj.fpvCamera.controls.enabled = false;

    setNightMode(servObj.nightMode);
    applyRoofColor(servObj.house.roofColor)

    
});

document.querySelector('#view-fpv').addEventListener('pointerdown', () => {
    const annotations = document.querySelectorAll('.ann_point');

    if (activeViewMode.isFPV === true) return;
    activeViewMode.setViewMode('fpv');

    servObj.isFPV = true;

    console.log(document.querySelectorAll('.ann_point'));

    annotations.forEach((el) => {
        if (el.classList.contains('d-none')) return;
        el.classList.add('d-none');
    });

    document.querySelector('#camera-autorotate').style.opacity = 0;
    document.querySelector('#camera-autorotate').style.pointerEvents = 'none';
    //document.querySelector("#camera-autorotate button").classList.remove("active")

    servObj.autorotate = true;
    let event = new Event('pointerdown');
    document.querySelector('#camera-autorotate button').dispatchEvent(event);

    if (servObj.nightMode) {
        scene.background = nightHDRI;
        scene.backgroundIntensity = 0.75;
    } else {
        scene.background = dayHDRI;
        scene.backgroundIntensity = 2;
    }

    servObj.fpvCamera.controls.setTarget(-7, 1.8, 14.66);
    servObj.fpvCamera.controls.distance = 0.01;
    servObj.fpvCamera.controls.azimuthAngle = -1.1810891801144154;
    servObj.fpvCamera.controls.polarAngle = 1.5544401102687613;
    scene.setActiveCamera(servObj.fpvCamera);

    document.querySelector('#view-3d').classList.remove('active');
    document.querySelector('#view-2d').classList.remove('active');
    document.querySelector('#view-fpv').classList.add('active');

    servObj.perspectiveCamera.controls.enabled = false;
    servObj.orthoCamera.controls.enabled = false;
    servObj.fpvCamera.controls.enabled = true;

    applyRoofColor(servObj.house.roofColor)
});
